var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tj-checkbox"},[_c('div',{staticClass:"tj-checkbox__input",class:[
    _vm.getChecked && 'tj-checkbox__input_checked',
    _vm.disabled && 'tj-checkbox__input_disabled'
  ],on:{"click":_vm.toggleCheck}},[(_vm.getIconName)?_c('TJIcon',{staticClass:"tj-checkbox__icon",attrs:{"name":_vm.getIconName,"size":16}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }